import React from "react";
import { Box } from "@mui/material";

const FieldToolPreviewOverlay = ({ fields = [] }) => {
  if (!fields.length) return null;

  return (
    <>
      {fields.map((field, index) => (
        <Box
          key={index}
          sx={{
            position: "absolute",
            left: `${field.x}px`,
            top: `${field.y}px`,
            width: `${field.width}px`,
            height: `${field.height}px`,
            border: "1px solid #000",
          }}
        />
      ))}
    </>
  );
};

export default FieldToolPreviewOverlay;
